export default __webpack_public_path__ + "static/media/622.25d16077.png";